export default "__VITE_PUBLIC_ASSET__a48c3e35__"